import React, { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { FcPhoneAndroid, FcInfo, FcIdea } from "react-icons/fc";
import { GrMail } from "react-icons/gr";
import { MdDoNotDisturbAlt } from "react-icons/md";
import { useSelector } from "react-redux";
import { Baseurl } from "../../../config/BaseUrl";
import axios from "axios";
import { Link } from "react-router-dom";
import moment from "moment/moment";
import DashboardPropertyCard from "./DashboardPropertyCard";
import "./DashboardListingsNew.css";

const UnderScreening = () => {
  const { loginData } = useSelector((store) => store.Athentication);

  const [showProperty, setshowProperty] = useState([]);
  const [propertyloading, setPropertyloading] = useState(true);

  useEffect(() => {
    const userId = loginData._id;

    try {
      const fetchdata = async () => {
        const url = `${Baseurl}/api/v1/property/underscreening/${userId}`;
        const fetchProperty = await axios(url);
        if (fetchProperty.data.success === true) {
          let reportedProperty = fetchProperty.data.property;
          setshowProperty(reportedProperty);
        }
      };
      fetchdata();
    } catch (error) {}
  }, []);
  return (
    <div className="mgh-dl-container">
      {/* ================= Header Status Bar ================= */}
      <div className="mgh-dl-info-bar">
        <h4 className="mgh-dl-count-heading">
          <span>Underscreening Listings</span>
          <span className="mgh-dl-count-pill">
            {showProperty.length}{" "}
            {showProperty.length === 1 ? "Property" : "Properties"}
          </span>
        </h4>

        <div className="mgh-dl-filters-row">
          <span className="mgh-dl-filter-tag">
            <span>Showing: Underscreening</span>
          </span>
        </div>
      </div>

      {showProperty.length > 0 ? (
        showProperty.map((property, index) => (
          <DashboardPropertyCard
            key={property._id || index}
            property={property}
            packageType={loginData?.packageType || "UNDERSCREENING"}
          />
        ))
      ) : (
        <div className="mgh-dl-empty-state">
          <div className="mgh-dl-empty-icon">🔍</div>
          <h3 className="mgh-dl-empty-title">No Underscreening Properties</h3>
          <p className="mgh-dl-empty-desc">
            You don't have any properties currently under moderation or review.
          </p>
        </div>
      )}
    </div>
  );
};

export default UnderScreening;
